import {NgModule} from '@angular/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {RouterModule} from '@angular/router';
import {SharedSearchModule} from 'src/app/app-common/shared-search.module';
import {SharedModule} from '../../app-common/shared.module';
import {AreaIconComponent} from './components/area-icon/area-icon.component';
import {FreeSearchComponent} from './components/free-search/free-search.component';
import {MegaMenuDesktopComponent} from './components/mega-menu-desktop/mega-menu-desktop.component';
import {PlacesDropdownPanelV2Component} from './components/places-dropdown-panel-v2/places-dropdown-panel-v2.component';
import {PlacesFakeDropdownV2Component} from './components/places-fake-dropdown-v2/places-fake-dropdown-v2.component';
import {SearchWidgetV2DesktopComponent} from './components/search-widget-v2-desktop/search-widget-v2-desktop.component';
import {SearchWidgetWrapperComponent} from './components/search-widget-wrapper/search-widget-wrapper.component';
import {SearchWidgetTopPageWrapperComponent} from './components/search-widget-toppage-wrapper/search-widget-toppage-wrapper.component';
import {SearchCategoriesMobilePanelComponent} from './components/search-categories-mobile-panel/search-categories-mobile-panel.component';
import {SearchPlacesMobilePanelComponent} from './components/search-places-mobile-panel/search-places-mobile-panel.component';
import {InViewportModule} from 'ng-in-viewport';
import {SearchWidgetV4MobileComponent} from './components/search-widget-v4-mobile/search-widget-v4-mobile.component';
import {SearchWidgetV4MobileExpandedComponent} from './components/search-widget-v4-mobile-expanded/search-widget-v4-mobile-expanded.component';
import {SearchWidgetV4MobileFreeSearchFormComponent} from './components/search-widget-v4-mobile-expanded/search-widget-v4-mobile-free-search-form/search-widget-v4-mobile-free-search-form.component';
import {SearchWidgetV4MobilePlacesFormComponent} from './components/search-widget-v4-mobile-expanded/search-widget-v4-mobile-places-form/search-widget-v4-mobile-places-form.component';
import {SearchWidgetV4MobileSuggestionsComponent} from './components/search-widget-v4-mobile-expanded/search-widget-v4-mobile-suggestions/search-widget-v4-mobile-suggestions.component';
import {TopContentSpaceComponent} from './components/top-content-space/top-content-space.component';
import {UiIconComponent} from '../ui/ui-icon/ui-icon.component';
import {UiButtonComponent} from '../ui/ui-button/ui-button.component';

@NgModule({
  providers: [],
  imports: [
    SharedModule,
    SharedSearchModule,
    RouterModule,
    MatAutocompleteModule,
    InViewportModule,
    UiIconComponent,
    UiButtonComponent,
  ],
  declarations: [
    SearchWidgetV2DesktopComponent,
    PlacesFakeDropdownV2Component,
    PlacesDropdownPanelV2Component,
    FreeSearchComponent,
    MegaMenuDesktopComponent,
    AreaIconComponent,
    SearchWidgetWrapperComponent,
    SearchCategoriesMobilePanelComponent,
    SearchPlacesMobilePanelComponent,
    // SearchFiltersMobilePanelComponent,
    SearchWidgetTopPageWrapperComponent,
    SearchWidgetV4MobileComponent,
    SearchWidgetV4MobileExpandedComponent,
    SearchWidgetV4MobileFreeSearchFormComponent,
    SearchWidgetV4MobilePlacesFormComponent,
    SearchWidgetV4MobileSuggestionsComponent,
    TopContentSpaceComponent,
  ],
  exports: [
    SearchWidgetV2DesktopComponent,
    FreeSearchComponent,
    MegaMenuDesktopComponent,
    AreaIconComponent,
    SearchWidgetWrapperComponent,
    SearchWidgetTopPageWrapperComponent,
    SearchWidgetV4MobileComponent,
    SearchWidgetV4MobileExpandedComponent,
    SearchWidgetV4MobileFreeSearchFormComponent,
    SearchWidgetV4MobilePlacesFormComponent,
    SearchWidgetV4MobileSuggestionsComponent,
    TopContentSpaceComponent,
  ],
})
export class SearchWidgetV2Module {}
